import React, { useState } from "react";
import { Frameworks } from "./Frameworks";
import { Topics } from "../Topics/Topic";
import { Kpis } from "../KPI/Kpis";
import { CreateSectorQuestion } from "../../../Sector_Question_Manage/CreateSectorQuestion";
import GlobalControlFinancialYear from "../Control/GlobalControlFinancialYear";
import AdminSidebar from "../../../sidebar/admin_sidebar";
import AdminHeader from "../../../header/admin_header";
import { useLocation } from "react-router-dom";
import { SectorQuestionFrameworkWise } from "../../../Sector_Question_Manage/sectorQuestionindustrywise";

export const FrameworkTopicKpiTabs = (props) => {
  const [data, setData] = useState(props.data);
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("financial");

  const [activeFramework, setActiveFramework] = useState(false);
  const [activeQuestionListShow, setActiveQuestionListShow] = useState(false);
  const [activeTopic, setActiveTopic] = useState(false);
  const [activeAddQuestionData, setActiveAddQuestionData] = useState(false);
  const [activeQuestionList, setActiveQuestionList] = useState(false);
  const [currentTopicData, setCurrentTopicData] = useState({});
  const [currentAddFrameworkQuestionData, setCurrentAddFrameworkQuestionData] =
    useState({});
  const [currentAddTopicQuestionData, setCurrentAddTopicQuestionData] =
    useState({});

  const [activeKPI, setActiveKPI] = useState(false);
  const [currentKPIData, setCurrentKPIData] = useState({});

  const handleFrameworkChangeHandler = (data, tabId) => {
    setActiveFramework(true);
    setActiveTab(tabId);
    setData(data);
  };

  const handleTopicChangeHandler = (data, finalYearData, tabId) => {
    setActiveTopic(true);
    setActiveTab(tabId);
    setCurrentTopicData(data);
    
    setData(finalYearData);
    setCurrentAddFrameworkQuestionData(data);
  };

  const handleAddFrameworkQuestionChangeHandler = (data) => {
    setActiveAddQuestionData(true);
    setCurrentAddFrameworkQuestionData(data);
  };

  const handleActiveQuestionListHandler = (data) => {
    // setActiveQuestionList(true);
    // setCurrentAddFrameworkQuestionData(data);
  };

  const handleAddTopicQuestionChangeHandler = (data, framworkData) => {
    setActiveAddQuestionData(true);
    framworkData["topic_id"] = data.id;
    setCurrentAddFrameworkQuestionData(framworkData);
  };

  const handleAddKpiQuestionChangeHandler = (data, topicData, tabId) => {
    setActiveAddQuestionData(true);
    setActiveTab(tabId);
    topicData["kpi_id"] = data.id;
    setCurrentAddFrameworkQuestionData(topicData);
    setCurrentAddTopicQuestionData(data);
  };

  const handleKPIChangeHandler = (
    data,
    finalYearData,
    frameworkData,
    tabId
  ) => {
    frameworkData["topic_id"] = data.id;
    setCurrentAddFrameworkQuestionData(frameworkData);
    setActiveTab(tabId);
    // setActiveKPI(true);
    setCurrentKPIData(data);
    setData(finalYearData);
  };

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
  };

  const handleFrameworkTabClose = (event, tabId) => {
    event.stopPropagation();
    if (activeTab === tabId) {
      setActiveTab("financial");
      setActiveFramework(false);
      setActiveTopic(false);
      setActiveKPI(false);
      setActiveQuestionList(false);
    }
  };

  const handleTopicTabClose = (event, tabId) => {
    event.stopPropagation();
    if (activeTab === tabId) {
      setActiveTab("framework");
      setActiveTopic(false);
      setActiveKPI(false);
      setActiveQuestionList(false);
    }
  };

  const handleKpiTabClose = (event, tabId) => {
    event.stopPropagation();
    if (activeTab === tabId) {
      setActiveTab("topic");
      setActiveKPI(false);
    }
  };

  return (
    <div>
      <AdminSidebar dataFromParent={location.pathname} />
      <AdminHeader />
      <div className="main_wrapper">
        <div className="inner_wraapper">
          <div className="color_div_on framwork_2">
            <div className="tab-container">
              <div className="tab-menu border-bottom mb-2 d-flex align-items-center justify-content-between">
                <ul>
                  {/* --------------- Financial Year Tab ----------------------- */}

                  <li>
                    <div
                      className={`tab-a ${
                        activeTab === "financial" ? "active-a" : ""
                      }`}
                      onClick={() => handleTabClick("financial")}
                      data-id="financial"
                    >
                      Financial Year
                    </div>
                  </li>

                  {/* --------------- Framework Tab ----------------------- */}

                  <li>
                    <div
                      className={`tab-a ${
                        activeTab === "framework"
                          ? "active-a"
                          : "" ||
                            (activeFramework === true ? "d-block" : "d-none")
                      }`}
                      onClick={() => handleTabClick("framework")}
                      data-id="framework"
                    >
                      Framework
                      <span
                        className="close_tab_cell"
                        title="Close Framework"
                        onClick={(e) => handleFrameworkTabClose(e, "framework")}
                      >
                        <i className="fas fa-times-circle"></i>
                      </span>
                    </div>
                  </li>

                  {/* --------------- Topic Tab ----------------------- */}

                  <li>
                    <div
                      className={`tab-a ${
                        (activeTab === "topic" ? "active-a" : "") ||
                        (activeTopic === true ? "d-block" : "d-none")
                      }`}
                      onClick={() => handleTabClick("topic")}
                      data-id="topic"
                    >
                      Topic{" "}
                      <span
                        className="close_tab_cell"
                        title="Close Topic"
                        onClick={(e) => handleTopicTabClose(e, "topic")}
                      >
                        <i className="fas fa-times-circle"></i>
                      </span>
                    </div>
                  </li>

                  {/* --------------- KPI Tab ----------------------- */}

                  <li>
                    <div
                      className={`tab-a ${
                        (activeTab === "kpi" ? "active-a" : "") ||
                        (activeKPI === true ? "d-block" : "d-none")
                      }`}
                      onClick={() => handleTabClick("kpi")}
                      data-id="kpi"
                    >
                      KPI{" "}
                      <span
                        className="close_tab_cell"
                        title="Close Kpi"
                        onClick={(e) => handleKpiTabClose(e, "kpi")}
                      >
                        <i className="fas fa-times-circle"></i>
                      </span>
                    </div>
                  </li>

                  {/* --------------- Add Question Tab ----------------------- */}

                  <li>
                    <div
                      className={`tab-a ${
                        (activeTab === "addQuestion" ? "active-a" : "") ||
                        (activeAddQuestionData === true ? "d-block" : "d-none")
                      }`}
                      onClick={() => handleTabClick("addQuestion")}
                      data-id="addQuestion"
                    >
                      Add Question
                      <span
                        className="close_tab_cell"
                        title="Close Question"
                        onClick={(e) => handleKpiTabClose(e, "addQuestion")}
                      >
                        <i className="fas fa-times-circle"></i>
                      </span>
                    </div>
                  </li>

                  {/* --------------- Question List Tab ----------------------- */}

                  <li>
                    <div
                      className={`tab-a ${
                        (activeTab === "questionList" ? "active-a" : "") ||
                        (activeQuestionList === true ? "d-block" : "d-none")
                      }`}
                      onClick={() => handleTabClick("questionList")}
                      data-id="questionList"
                    >
                      Question List
                      <span
                        className="close_tab_cell"
                        title="Close Question"
                        onClick={(e) => handleKpiTabClose(e, "questionList")}
                      >
                        <i className="fas fa-times-circle"></i>
                      </span>
                    </div>
                  </li>
                </ul>
                <div>
                  <p>
                    <strong>
                      {data && data?.country_name} &nbsp;&nbsp;
                      {data && data?.financial_year_value}
                    </strong>
                  </p>
                </div>
              </div>
              {/* --------------- Financial Year Tab ----------------------- */}
              <div
                className="tab"
                data-id="financial"
                style={{
                  display: activeTab === "financial" ? "block" : "none",
                }}
              >
                <GlobalControlFinancialYear
                  handleFrameworkChangeHandler={handleFrameworkChangeHandler}
                />
              </div>
              {/* --------------- Framework Tab ----------------------- */}
              <div
                className="tab"
                data-id="framework"
                style={{
                  display: activeTab === "framework" ? "block" : "none",
                }}
              >
                <Frameworks
                  financial_year_id={data}
                  handleTopicChangeHandler={handleTopicChangeHandler}
                  handleAddFrameworkQuestionChangeHandler={
                    handleAddFrameworkQuestionChangeHandler
                  }
                />
              </div>
              {/* --------------- Topic Tab ----------------------- */}
              { activeTab ==="topic" &&    <div
                className="tab"
                data-id="topic"
                style={{ display: activeTab === "topic" ? "block" : "none" }}
              >
                <Topics
                  frameworkData={currentTopicData}
                  financial_year_id={data}
                  handleKPIChangeHandler={handleKPIChangeHandler}
                  handleAddTopicQuestionChangeHandler={
                    handleAddTopicQuestionChangeHandler
                  }
                />
              </div>}
              {/* --------------- Add Question Tab ----------------------- */}
           
              <div
                className="tab"
                data-id="addQuestion"
                style={{
                  display: activeTab === "addQuestion" ? "block" : "none",
                }}
              >
                <CreateSectorQuestion
                  currentFrameworkData={currentAddFrameworkQuestionData}
                  currentTopicData={currentAddTopicQuestionData}
                  topicData={currentKPIData}
                />
              </div>
              {/* --------------- Question List Tab ----------------------- */}
              { activeTab ==="questionList" &&   <div
                className="tab"
                data-id="questionList"
                style={{
                  display: activeTab === "questionList" ? "block" : "none",
                }}
              >
                <SectorQuestionFrameworkWise
                  financial_year_id={data}
                  currentFrameworkData={currentAddFrameworkQuestionData}
                  handleActiveQuestionListHandler={handleActiveQuestionListHandler}
                />
              </div>}
              {/* --------------- KPI Tab ----------------------- */}
              { activeTab ==="kpi" &&    <div
                className="tab"
                data-id="kpi"
                style={{ display: activeTab === "kpi" ? "block" : "none" }}
              >
                <Kpis
                  topicData={currentKPIData}
                  currentAddFrameworkQuestionData={
                    currentAddFrameworkQuestionData
                  }
                  handleAddKpiQuestionChangeHandler={
                    handleAddKpiQuestionChangeHandler
                  }
                />
              </div>}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
